import React from "react";
import useSWR from "swr";
import { VriApi } from "../../configs/appRoute";
import { AxiosAuth } from "../../core";
import { ApiResponse } from "../../models/api/common";
import { UtilsJQuery } from "../../utils/jQuery";
import { AppConstants } from "../../configs/appConstants";

export function useLobbyConferenceTin(roomId: string) {
  const url = roomId ? VriApi.Conference.GetConferenceTinByRoomId.Root(roomId) : null;
  const { data } = useSWR<string>(url, () =>
    AxiosAuth.get<ApiResponse<string>>(url!).then(response => response.data.data)
  );
  return { conferenceTin: data ?? "" };
}

export function useFunctionalityConferenceRoomInfo() {
  const isRoomStarted = React.useCallback(async (roomId: string) => {
    const btnLoading = UtilsJQuery.Ladda(".login-from-submit-btn");
    btnLoading.start?.();
    try {
      const response = await AxiosAuth.get<{ isRoomCreated: boolean }>(
        VriApi.Room.IsRoomCreated.Load(roomId)
      );
      return response.status === AppConstants.Api.StatusOK ? response.data : null;
    } finally {
      btnLoading.stop?.();
    }
  }, []);

  return { isRoomStarted };
}
